import { getRequiredTableNames } from '../source/required-csv-files';
import { OasisSourceHandler } from './source';

export function getOasisExportTableNames(): string[] {
  return getRequiredTableNames(new OasisSourceHandler().entityHandlers).sort();
}
